var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA2BtPowerSupply(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 49H40v20h-4V49H25l11-18.64V7h4v23.36L51 49z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A2_BT_Power_Supply.38c94a47.svg";
export { SvgA2BtPowerSupply as ReactComponent };